import { PT } from '@gasbuddy/react';

export const BrandDescription = ({ brand }) => {
  const brandDescription = [];
  if (brand.is_cstore) {
    brandDescription.push('C-store Brand');
  }
  if (brand.is_fuel) {
    brandDescription.push('Fuel Brand');
  }
  if (brand.allow_brand_sharing === false) {
    brandDescription.push('Owner / Operated');
  }
  if (brand.description !== '') {
    brandDescription.push(brand.description);
  }
  return brandDescription.join(', ');
};

BrandDescription.defaultProps = {
  brand: {
    description: '',
    is_cstore: false,
    is_fuel: false,
    allow_brand_sharing: null,
  },
};

BrandDescription.propTypes = {
  brand: PT.shape(
    {
      description: PT.string,
      is_cstore: PT.boolean,
      is_fuel: PT.boolean,
      allow_brand_sharing: PT.boolean,
    },
  ),
};
